"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricSparkline = MetricSparkline;
var jsx_runtime_1 = require("react/jsx-runtime");
function MetricSparkline(props) {
    var data = props.data, tone = props.tone;
    var WIDTH = 160;
    var HEIGHT = 36;
    var STROKE_BY_TONE = { success: "#127807", warning: "#eda100", critical: "#d03b3b", neutral: "#898781" };
    if (data.length < 2) {
        return (0, jsx_runtime_1.jsx)("div", { className: "h-9", "aria-hidden": "true" });
    }
    var max = Math.max.apply(Math, data);
    var min = Math.min.apply(Math, data);
    var range = max - min || 1;
    var toPoint = function (value, index) { return ({
        x: (index / (data.length - 1)) * WIDTH,
        y: HEIGHT - 3 - ((value - min) / range) * (HEIGHT - 6),
    }); };
    var points = data.map(toPoint);
    var line = points.map(function (point) { return "".concat(point.x.toFixed(1), ",").concat(point.y.toFixed(1)); }).join(" ");
    var area = "0,".concat(HEIGHT, " ").concat(line, " ").concat(WIDTH, ",").concat(HEIGHT);
    var last = points[points.length - 1];
    var stroke = STROKE_BY_TONE[tone];
    return ((0, jsx_runtime_1.jsxs)("svg", { viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT), preserveAspectRatio: "none", className: "w-full h-9", "aria-hidden": "true", children: [(0, jsx_runtime_1.jsx)("polygon", { points: area, fill: stroke, opacity: 0.08 }), (0, jsx_runtime_1.jsx)("polyline", { points: line, fill: "none", stroke: "#c3c2b7", strokeWidth: 1.5, strokeLinejoin: "round", strokeLinecap: "round" }), (0, jsx_runtime_1.jsx)("circle", { cx: last.x, cy: last.y, r: 3, fill: stroke })] }));
}
